// Shared review data for list and detail pages.
const reviews = [
  {
    title: "Saudia Economy",
    slug: "saudia-economy-sv144-cdg-ruh",
    route: "SV144 CDG → RUH",
    aircraft: "Boeing 777-300ER",
    flightTime: "6h 5m",
    seat: "54A",
    date: "March 2026",
    rating: 3,
    logo: "/assets/Logo-Saudia-.avif",
    images: [
      "/assets/SV-777-seats.jpeg",
      "/assets/SV-777-cabin.jpg",
      "/assets/SV-777-wing.JPG",
      "/assets/SV-777-food.jpeg",
    ],
    story:
      "This was one of the most confusing flights of my life, it's like the Saudia I have become used to doesn't exist anymore, gone are the amenity kits, the modern IFE and the free seat selection. This flight on Saudia's 777 was really a completely different airline, first of all, I want to point out that I don't dislike Saudia, and I want them to succeed in a region with growing instablility and competition. So, this trip took me from Paris Charles De Gaulle to Riyadh on Saudia's packed, old 777. Paris is always an experience, especially flying from Termainal 1 - it's a bit of a crowded mess. It seems like this flight is mainly taken by Saudis going to Riyadh - evident from the people in the check-in queue, and so this flight was quite a different experience from the flights I have taken with Saudia to Jeddah. Unusually this whole experience felt alot more like a low-cost airline - for one, during online check-in there was a surprising lack of free seat selection, something that seems to have disappeared off of most middle eastern airlines. But the things I noticed the most about Saudia on this trip was the lack of amenity kits and the ageing hardware that kept on glitching whenever we tapped things - of course the hardware is because of the 777 and the older seats used on this flight, but the amenity kit was absent for no particular reason - and what makes it even more confusing, was that on a flight I took with them a few weeks later, they did provide amenity kits! However, the food was still pretty good - consisting of a pasta dish (a chicken and beef option were also provided), a salad, a mousse and a water bottle (and a beverage of choice) , pillows and blankets were provided, the crew were alright (but a bit robotic), and the seat was fairly comfortable (even if a bit old). So I probably will fly Saudia again - specifically for the great price - but I hope to see them improve.",
    videoID: ""
  },

  {
    title: "Ryanair Economy",
    slug: "ryanair-economy-fr2814-stn-cgn",
    route: "FR2814 STN → CGN",
    aircraft: "Boeing 737 MAX 8-200",
    flightTime: "1h 47m",
    seat: "34D",
    date: "February 2026",
    rating: 2,
    logo: "/assets/FR copy.png",
    images: [
      "/assets/FR-737MAX-seats.jpeg",
      "/assets/FR-737MAX-cabin.jpeg",
      "/assets/FR-737MAX-tail.jpeg",
      "/images/IMG_4075 (image(2)).jpeg",
    ],
    story:
      "Ryanair is known for their no-frills business model, this means it can charge rock-bottom prices, but with a catch, no extras! For this flight, I challenged myself to fly with zero paid extras, no checked luggage, no extra food, no seat selection! This of course meant that I did not get a window seat, but it instead meant I had a super cheap flight from London Stansted to Cologne, Germany! This trip obviously started off in the Ryanair capital of the world, London Stansted. Because I had no checked luggage, I went straight to the crowded security line - after getting through, I braved duty-free, and got myself some sushi at one of many fast-food chains in Stansted. Soon, my flight was called and we headed to the gate - of course boarding last, because priority boarding is basically pointless! My seat for today would be 34D, an aisle seat - the seat I had been allocated during ONLINE check-in. This flight was pretty much completely uneventful - bar the PAID snack trolley that was also selling SCRATCH CARDS and CIGARETTES! This flight was one of the most tiring in my life, but I'm glad I now know what I should avoid in future!",
    videoID: "nt69ebmsfrI"
  },

  {
    title: "British Airways Economy",
    slug: "british-airways-economy-ba4453-rtm-lcy",
    route: "BA4453 RTM → LCY",
    aircraft: "Embraer E190",
    flightTime: "~1h 00m",
    seat: "17A",
    date: "January 2026",
    rating: 4,
    logo: "/assets/British-Airways-Logo.png",
    images: [
      "/assets/BA-190-seats.jpeg",
      "/images/IMG_4618.jpeg",
      "/images/IMG_4637.jpeg",
      "/assets/BA-190-food.jpeg",
    ],
    story:
      "This was one of the most exciting flights of my life! This was originally meant to be a simple flight from Amsterdam to London (Heathrow), but because of the snow in Amsterdam, basically every single flight was cancelled - including mine, so instead, British Airways put us all on a specially chartered flight leaving the next day - from ROTTERDAM to LONDON CITY! This resulted in us scrambling to get to Rotterdam, but because the trains or buses weren't running, we resorted to calling an Uber, which costed a small fortune (BA paid for it). They then provided us with enough money to stay at the Ibis at Rotterdam Airport. The next morning we entered the airport, checked in and had breakfast at an Airside Café - this was again paid for by BA. Now for the actual flight; British Airways did a fantastic job - not only was the aircraft in a 2-2 (4 abreast) configuration, which means there are only aisle and window seats, but BA also provided a pretty decent snack service on a 1-hour flight! British Airways Cityflyer is a GEM in the British Airways fleet!",
    videoID: "nC9IXGwQ6IY"
  },

  {
    title: "Etihad Economy",
    slug: "etihad-economy-ey41-auh-ams",
    route: "EY41 AUH → AMS",
    aircraft: "Airbus A350-1000",
    flightTime: "8h 47m",
    seat: "28K → 29K",
    date: "January 2026",
    rating: 3,
    logo: "/assets/Etihad-airways-logo.svg.png",
    images: [
      "/assets/EY-350-seats.jpeg",
      "/assets/EY-350-food.jpeg",
      "/assets/EY-350-winglet.jpeg",
      "/assets/EY-350-VS.jpeg",
    ],
    story:
      "This was one hell of a flight, we start in Abu Dhabi Zayed Airport after just transiting from a 787 flight from Kuala Lumpur, this flight is operated by an A350-1000. For a start we were late to the gate, and then after getting onboard and to our seats, we find out much of my row is filled with the stench of vomit! I later see it on my pillow (which obviously wasn't changed) and on the overhead bin! Lord knows how it got there! Anyway after a seat move to the row behind, we take off and the meal service starts soon after, pretty good! I go for the pasta option. No, fast foward to the end of the flight, which after enduring a full 8 hours of vomit smell, we are informed that Amsterdam is full of snow and that we'll have to hold until a slot and gate frees up - we eventually land; the fact that multiple mishaps happened on this flight is remarkable. Somehow though I wasn't and I still am not too annoyed as, not only did we get compensation, but the crew were also very accommdating and changed the covers of the stained seats. This will go down as one of my most interesting flights ever - one for the books. THE VOMIT PLANE, we now call it in my family!",
    videoID: "6YFTWjdhpJ0"
  },

  {
    title: "Etihad Economy",
    slug: "etihad-economy-ey489-kul-auh",
    route: "EY489 KUL → AUH",
    aircraft: "Boeing 787-10",
    flightTime: "7h 14m",
    seat: "32A",
    date: "January 2026",
    rating: 5,
    logo: "/assets/Etihad-airways-logo.svg.png",
    images: [
      "/assets/Screenshot 2026-02-12 at 22.47.59.png",
      "/assets/Etihad_787_food.jpeg",
    ],
    story:
      "This was probably the most flawless flight I've taken in a LONG TIME, and definitely the best Etihad flight I took on this trip. We started off in Kuala Lumpur, and got to the airport, now I do have a few comments on the airport's interesting design but I'll leave that for the video, anyway, we got onto the plane and although the seats lacked the cool remotes that the 787-9 had, this 787-10 was still very nice, with very comfy seats, and one of the largest pillows I've ever seen in economy class, as well as a very fluffy blanket. The IFE was also very good, much better than the 777 I'd flown earlier in the trip, a much wider selection of everything, and just a much larger and higher resolution screen! The food was, like last time, great, with plenty of options - including a classic pasta dish, some mash with beef, and a chicken and rice option, all served with the usual sides. And of course, this flight wasn't that long (~7 hours) so I wasn't expecting a second meal service. However, they did come round with drinks mulitple times and towards the end served OREOS (with a more extensive dinks selection of course) - I believe they did have a little snack bar at the rear galley but I didn't check... So overall, this was a great flight with flawless... EVERYTHING! I applaud Etihad for this brilliant flight!",
    videoID: "QyKWkWcN2DU"
  },

  {
    title: "Cathay Pacific Economy",
    slug: "cathay-pacific-economy-cx789-hkg-bkk",
    route: "CX789 HKG → BKK",
    aircraft: "Airbus A330-300",
    flightTime: "3h 11m",
    seat: "72K",
    date: "December 2025",
    rating: 5,
    logo: "/assets/Cathay-Pacific-Logo.png",
    images: [
      "/assets/Image (12).jpeg",
      "/images/IMG_4619.jpeg",
      "/assets/Cathay_A330_food.jpeg",
      "/assets/Cathay_winglet.png",
    ],
    story:
      "This is one of the flights that I have been looking forward to since I booked it, I've always wanted to fly Cathay Pacific and although this flight was only ~3 hours long, it more than lived up to the hype that the internet had fed me, it exceeded it with flying colors! I started of this flight at Hong Kong's Chek Lap Kok airport - the one with the bridge - and we boarded the beauty, the A330. The crew's service was top-notch and I very much enjoyed the massive selection on offer on Cathay's IFE. As well as this, Cathay's in-house catering in Hong Kong did a fantastic job with the food, very delicious - it even came with complementary ICECREAM! Although the cabin was a little dated, and maybe the flight was shorter than I had hoped, and maybe I didn't get to try Cathay's FULL Long-Haul experience, I was more than happy with this flight, and a massive upgrade from the competition - the likes of THAI (sorry), AirAsia, Hong Kong Express (which is owned by Cathay Pacific) etc. Overall, this flight was great, VERY NICE, I would 100% do it again (maybe even long-haul in the future??)!",
    videoID: "XCsjAJMhWcc"
  },

  {
    title: "Etihad Economy (Police Incident)",
    slug: "etihad-economy-police-incident-ey870-auh-hkg",
    route: "EY870 AUH → HKG",
    aircraft: "Boeing 787-9",
    flightTime: "6h 51m",
    seat: "26A",
    date: "December 2025",
    rating: 5,
    logo: "/assets/Etihad-airways-logo.svg.png",
    images: ["/assets/Screenshot 2026-02-11 at 22.26.44.png"],
    story:
      "I was heavily debating not including this review as it was not filmed for YouTube, but it was one of the most eventful flights of my life. So this was meant to just be a normal flight from Abu Dhabi to Hong Kong, the usual Etihad experience, with a great seat (including cool remote controls - I made a YT short about that). But when we arrived into Hong Kong and got to the gate, we were told to sit down and check our valuables if anything had been STOLEN! WE WERE WAITING FOR THE POLICE!!! It turns out that a group of coordinated asian men had stolen a diamond necklace and diamond ring from a passenger who I only assume had brought it to Hong Kong to get good luck? Anyway, the police boarded our aircraft and started going to specific rows where those men had sat, they then proceeded to rip apart the seats, tearing of the seat cushions and pointing flashlights down the ridges. After about half an hour of this and a few men being escorted off the plane with luggage to be searched in a seperate jet bridge, we were let off the plane. What a crazy experience, too bad I didn't film the flight or anything - I could've started then and there, but then again I don't want trouble with Chinese police! But overall the flight was pretty good, but nothing too much different from a similar Etiahd flight I reviewed later in the trip (though on the 787-10 instead of the -9 (the -9 has remote controls and the -10 does not)). But still a crazy experience!!! ---------------- It turns out the men are adjacent to the Hong Kong mafia and are made to go onto these flights and steal valuables - it is also a repeated thing (has happened something like 5 times already!), and on this route aswell, which is a little worrying! there is a really detailed article about this incident on Simple flying, go check that out for more!",
    videoID: ""
  },

  {
    title: "Etihad Economy",
    slug: "etihad-economy-ey58-bru-auh",
    route: "EY58 BRU → AUH",
    aircraft: "Boeing 777-300ER",
    flightTime: "6h 49m",
    seat: "53A",
    date: "December 2025",
    rating: 5,
    logo: "/assets/Etihad-airways-logo.svg.png",
    images: ["/assets/Image (11).jpeg"],
    story:
      "This is one of Etihad's oldest aircraft, and it does show, from older IFE moniters, dated cabin design to fairly worn seats, you could tell this aircraft was nearly 14 years old, however I do commend Etihad for keeping it in such good condition and reupolstering the seats with the new design. All together I found the crew were very attentive and friendly, the food included options like beef and mash, chicken and rice or some curry, and the content on option was extensive, maybe not as much as the newer A350s (hint hint) but still miles ahead than the likes of Norse/Indigo. I really enjoyed this flight and I'm very glad we got seats in the last few rows where the cabin is slimmer so it is configured 2-4-2 instead of 3-4-3, otherwise I think my experience would have been a litttle different. Overall, Etihad blew away my expectations and I have alot more Etihad content to come. PLUS Etihad's hub in Abu Dhabi is georgous - a beautiful blend of modern architecture and traditional sandy destert tones! Very easy to transit in - very fast, and a great amount of shops and restaurants to pass time. (though our connections were very close together!)",
    videoID: "P63RLWre9Fk"
  },

  {
    title: "EasyJet Economy",
    slug: "easyjet-economy-u25707-sen-ams",
    route: "U25707 SEN → AMS",
    aircraft: "Airbus A320neo",
    flightTime: "1h 27m",
    seat: "9F",
    date: "December 2025",
    rating: 4,
    logo: "/assets/EasyJet_logo.svg.png",
    images: ["/assets/Image (10).jpeg"],
    story:
      "Southend Airport has always been special to me, being the smallest London airport it means the experience is super quick and efficient, though the shops airside were a little underwhelming I still was very impressed - it is now my favourite London Airport! This was one of the most exciting flights I've taken in a while, and it was a great way to kick off the trip. The flight was smooth and uneventful, but the highlight was the beauftiful view over the English channel and the incredible landing into the foggiest airport I've ever seen, literally under 20 meters visibility. The crew was friendly and efficient, and the overall experience was enjoyable, making it a memorable start to an exciting series of flights.",
    videoID: "0AvTiMiBXuA"
  },

  {
    title: "IndiGo Economy",
    slug: "indigo-economy-6e1052-bkk-bom",
    route: "6E1052 BKK → BOM",
    aircraft: "Airbus A321neo",
    flightTime: "4h 26m",
    seat: "7F",
    date: "November 2025",
    rating: 3,
    logo: "/assets/IndiGo_Airlines_logo.svg.png",
    images: ["/assets/Image (15).jpeg"],
    story:
      "The flight was uneventful and typical for the route. Check-in was slow, but the Coral Lounge made the wait more comfortable. The crew provided water during the delay, and while snacks and drinks were available for purchase, I stuck with my own. Aside from flying past a large cloud, the flight passed quickly, giving time to relax and watch downloaded content before landing near Mumbai.",
    videoID: "FYugMR7V92U"
  },

  {
    title: "Bangkok Airways Economy",
    slug: "bangkok-airways-economy-pg272-hkt-bkk",
    route: "PG272 HKT → BKK",
    aircraft: "Airbus A320",
    flightTime: "1h 29m",
    seat: "8A",
    date: "October 2025",
    rating: 5,
    logo: "/assets/Bangkok_Airways_Logo.svg.png",
    images: ["/assets/Image (14).jpeg"],
    story:
      "The short Bangkok Airways flight was quick and straightforward. Airport check-in and security were fast, lounges offered decent food and snacks (especially popcorn!), and boarding was organized despite a slight delay. The plane was noticeably old, but the seats and service were adequate, with a timely lunch and drinks service. The flight itself felt very short, and before long, we were already descending into Suvarnabhumi.",
    videoID: "OW6BUq3LEG0"
  },

  {
    title: "IndiGo Economy (Norse Lease)",
    slug: "indigo-economy-norse-lease-6e22-ams-bom",
    route: "6E22 AMS → BOM",
    aircraft: "Boeing 787-9",
    flightTime: "8h 30m",
    seat: "39A",
    date: "October 2025",
    rating: 4,
    logo: "/assets/IndiGo_Airlines_logo.svg.png",
    images: ["/assets/Image (13).jpeg"],
    story:
      "What started as a stressful check-in experience turned into a surprisingly smooth and memorable flight. We managed to get seats together and ended up with a free middle seat, enjoyed some unexpected Norwegian–Norse quirks on board, and even spotted a shooting star mid-flight. Despite small inconveniences like dimmed windows, limited charging ports, and slow meal collection, the crew, the atmosphere, and the smooth landing into Mumbai made the journey far better than expected.",
    videoID: "kGnGlGt-Dco"
  },

  {
    title: "Thai Airways Economy",
    slug: "thai-airways-economy-tg136-bkk-cei",
    route: "TG136 BKK → CEI",
    aircraft: "Airbus A320",
    flightTime: "1h 28m",
    seat: "41H",
    date: "August 2025",
    rating: 4,
    logo: "/assets/Thai_Airways_logo.svg.png",
    images: ["/assets/Image (4).jpeg"],
    story:
      "The Thai Airways flight was smooth and enjoyable. The seat was comfortable, though lacking in-seat charging, and the taxi around Suvarnabhumi gave a great opportunity to spot rare aircraft parked at the airport—a common practice for short-haul and regional flights. Takeoff offered beautiful views of Bangkok and the airport, and the cabin experience was fun with ceiling screens displaying brief ads and attentive crew handing out goody bags and drinks. The scenic Thai landscape made the flight even more pleasant, and the attentive service added a nice personal touch, making this short hop a very enjoyable experience.",
    videoID: "n_o-uCUZOBQ"
  },

  {
    title: "Thai Airways Economy",
    slug: "thai-airways-economy-tg955-osl-bkk",
    route: "TG955 OSL → BKK",
    aircraft: "Airbus A350-900",
    flightTime: "11h 18m",
    seat: "46A",
    date: "August 2025",
    rating: 5,
    logo: "/assets/Thai_Airways_logo.svg.png",
    images: ["/assets/Image (5).jpeg"],
    story:
      "The flight was comfortable, efficient, and very well-serviced. Despite the initial rush at the airport and a lost bag reminder, boarding was smooth, and the seat offered good legroom, recline, and amenities including USB and universal power ports. The IFE was solid with movies, TV, and extras like a moving map and exterior camera. Meals were tasty and thoughtfully presented, and the crew kept the cabin and toilets spotless throughout. Combined with a smooth takeoff, decent sleep, and sunrise views before landing, the flight provided a pleasant and enjoyable journey.",
    videoID: "Aa03AJwh9f8"
  },

  {
    title: "Ethiopian Airlines Economy",
    slug: "ethiopian-airlines-economy-et808-jnb-add",
    route: "ET808 JNB → ADD",
    aircraft: "Airbus A350-900",
    flightTime: "5h 13m",
    seat: "58L",
    date: "April 2025",
    rating: 5,
    logo: "/assets/Ethiopian_Airlines_Logo.svg.png",
    images: ["/assets/Image (6).jpeg"],
    story:
      "The first Ethiopian A350 flight was a genuinely impressive experience. While the safety video felt amateur and unintentionally funny, everything else about the product exceeded expectations: a comfortable seat, excellent charging options, decent IFE, and surprisingly delicious food with multiple choices. The adjustable headrest made a big difference for taller passengers, and the distant thunderstorm over Kenya created an unforgettable in-flight moment. In all, it was a comfortable, well-equipped, and memorable flight.",
    videoID: "WNAmr-5lGGk"
  },

  {
    title: "FlySafair Economy",
    slug: "flysafair-economy-fa478-hla-dur",
    route: "FA478 HLA → DUR",
    aircraft: "Boeing 737-800",
    flightTime: "1h 9m",
    seat: "22A",
    date: "April 2025",
    rating: 3,
    logo: "/assets/FlySafair_Logo_Transparent_Background.png",
    images: ["/assets/Image (7).jpeg"],
    story:
      "The flight was simple but comfortable. The paid snacks and drinks were expected, and while the cabin had thin, non-reclining seats similar to Ryanair, the legroom was good. Boarding and deboarding were very orderly, with the crew managing groups efficiently, which made exiting smooth and stress-free. Despite the basic setup, the flight was generally a good and comfortable experience.",
    videoID: "bY2J-BaVT4w"
  },

  {
    title: "RwandAir Economy",
    slug: "rwandair-economy-wb700-wb108-cdg-jnb",
    route: "WB700 & WB108 CDG → JNB (via KGL)",
    aircraft: "Airbus A330-300 & 737-800",
    flightTime: "9h 5m & 3h 57m",
    seat: "21A & 21F",
    date: "April 2025",
    rating: 3,
    logo: "/assets/RwandAir_Logotype.png",
    images: ["/assets/Image.jpeg"],
    story:
      "The flight had a mixed experience. Boarding was fast but chaotic, and while the IFE initially had issues, it eventually worked well with plenty of movies to choose from. The abundance of juice options and a solid six hours of sleep were definite highlights, though minor annoyances like outdated moving maps, lack of WiFi, and repeated ads for Rwanda detracted slightly. Meals were basic but sufficient, and the cabin lighting created a nice sunrise effect. While not the airline’s best offering, the flight was manageable, comfortable in parts, and got us safely to our destination despite earlier delays.",
    videoID: "KaTbTOHbTaM"
  },

  {
    title: "Turkish Airlines Economy",
    slug: "turkish-airlines-economy-tk209-tk1983-sin-lhr",
    route: "TK209 & TK1983 SIN → LHR (via IST)",
    aircraft: "Airbus A350-900",
    flightTime: "11h 48m & 4h 15m",
    seat: "24A & 24A",
    date: "January 2025",
    rating: 5,
    logo: "/assets/Turkish_Airlines_logo_2019_compact.svg.png",
    images: ["/assets/Image (1).jpeg"],
    story:
      "The flight on the A350 was a mix of highs and minor annoyances. The seat, legroom, and amenity kit were excellent, and the IFE offered an impressive selection of movies and shows, even if some ads were annoying and Bluetooth headphones couldn’t connect. Meals were enjoyable, and the ambient lighting created a relaxing atmosphere, though the cabin felt warm and the crew rarely interacted during dimmed periods. Boarding and airport procedures were crowded but manageable, and the landing was a bit firm. Despite small frustrations, the flight was comfortable, entertaining, and a solid experience overall.",
    videoID: "DAQ2IYlViEU"
  },

  {
    title: "AirAsia Economy",
    slug: "airasia-economy-fd357-dmk-sin",
    route: "FD357 DMK → SIN",
    aircraft: "Airbus A320",
    flightTime: "2h 39m",
    seat: "22A",
    date: "January 2025",
    rating: 4,
    logo: "/assets/AirAsia-Logo-2009.png",
    images: ["/assets/Image (8).jpeg"],
    story:
      "The flight and airport experience were fairly straightforward but a bit chaotic. Don Mueang’s small size and strict baggage rules made things hectic, especially at passport control and security, but boarding went smoothly, and a friendly seat swap made the flight more comfortable. The flight itself was uneventful, though the landing offered spectacular city views. Changi Airport and the Crowne Plaza stay added convenience and comfort, making the overall journey smooth despite the minor chaos at Don Mueang.",
    videoID: "7xaK10g-uXM"
  },

  {
    title: "Saudia Economy",
    slug: "saudia-economy-sv844-jed-bkk",
    route: "SV844 JED → BKK",
    aircraft: "Boeing 787-10",
    flightTime: "7h 20m",
    seat: "42A",
    date: "December 2024",
    rating: 5,
    logo: "/assets/Logo-Saudia-.avif",
    images: ["/assets/Image (2).jpeg"],
    story:
      "The flight was decent—not great, but not terrible. The crew was thoughtful, the amenities and care kits were a nice touch, and the IFE offered a strong music selection, including multiple Taylor Swift albums. Meals were hit-or-miss, and the lack of WiFi, Bluetooth, and pizza sauce were minor annoyances. Despite some small technical hiccups and locked windows, the 787 provided a comfortable journey, topped off with a smooth landing on Bangkok’s new runway 02L.",
    videoID: "_3NDqtU9P5E"
  },

  {
    title: "British Airways Business",
    slug: "british-airways-business-ba326-lhr-cdg",
    route: "BA326 LHR → CDG",
    aircraft: "Airbus A321neo",
    flightTime: "1h 10m",
    seat: "1F",
    date: "December 2024",
    rating: 4,
    logo: "/assets/British-Airways-Logo.png",
    images: [
      "/assets/Image (9).jpeg",
      "/assets/BA_biz_food.png",
    ],
    story:
      "The journey was mostly smooth despite a slight delay and very late baggage arrival. The lounge visit helped pass the time comfortably, and the food was enjoyable, scoring around 5–8/10. Even with the minor hiccups, the flight experience was pleasant and manageable.",
    videoID: "HJ7bD2TEoDY"
  },
];

export default reviews;
